import CONTACT_INFO from './tsContactInfo';

/* eslint-disable quotes, max-len */
export const SUMMARY_CONTENT = `Trust Science Inc. and www.TrustScience.com USA Inc. (together with their \
affiliates, “Trust Science,” “we,” “us,” and “our”) are committed to protecting the privacy of your \
information. By accessing or using the Smart Consent™ App or any website through which Trust Science® \
services are available (“Sites”), you expressly consent to the collection, use, and disclosure of \
your data in accordance with this Privacy Policy.`;

export const CONTENT = [
  {
    title: 'Use of Your Data',
    content: `Trust Science applies complex algorithms and machine learning to your data to create a trustworthiness \
profile, Trust Report™, Six Score™, and other analysis. In addition, we use your data internally for the following \
purposes:`,
  },
  {
    list: [
      `Generating your Trust Report, Six Score, and other analysis;`,
      `Developing and improving our Trust Scoring models;`,
      `Processing your transactions;`,
      `Sending you service updates, marketing notices, and promotional offers;`,
      `Serving relevant ads to you when you visit the App or Sites;`,
      `Troubleshooting problems with our service; and`,
      `Complying with applicable law and preventing fraud or other illegal use of the service.`,
    ],
  },
  {
    content: `We and our third-party service providers, including our marketing partners and analytics providers, may use mobile \
tracking technologies and website cookies to distinguish you from other users of the App or Sites. This helps us \
provide you with a good experience when you use the App or Sites and allows us to improve the App and Sites.`,
  },
  {
    title: 'Disclosure of Your Data',
    content: `You agree that Trust Science may provide any customer of Trust Science that you specifically designate \
as an authorized recipient with a Trust Report, Six Score, or other analysis containing your data.

In addition, Trust Science may disclose your data to the following recipients:`,
  },
  {
    list: [
      `Any member of Trust Science and any sub-contractors, agents, service providers, partners, or associates of Trust Science (including their employees, directors, and officers);`,
      `Persons acting on your behalf, payment recipients, beneficiaries, account nominees, intermediaries, correspondent and agent banks, clearing houses, clearing or settlement systems, market counterparties, upstream withholding agents, swap or trade repositories, stock exchanges, and companies in which you have an interest in securities (where such securities are held by our partners for you);`,
      `Any financial institutions, credit reference agencies, or credit reporting agencies for the purposes of obtaining or providing trust references;`,
      `Any third party to whom we provide introductions or referrals;`,
      `Any party in connection with any Trust Science business transfer, disposal, merger, or acquisition;`,
      `Third-party service providers under contract with Trust Science that help us with our business operations, such as transaction processing, fraud prevention, and marketing, and only as necessary to provide you with our service; and`,
      `Law enforcement, government officials, or other third parties, but only in connection with a formal request, subpoena, court order, or similar legal procedure, or when we believe in good faith that disclosure is necessary to comply with the law, prevent physical harm or financial loss, report suspected illegal activity, or investigate violations of our Terms of Use or for any other legally permissible purpose.`,
    ],
  },
  {
    title: 'Data We Collect',
    content: `Trust Science collects the following types of data:`,
  },
  {
    list: [
      `Information you provide by registering to use the App or any of our services, filling in forms, sharing data via the App’s social media functions, corresponding with us, or reporting a problem;`,
      `Information stored on your mobile device, including contact lists, call logs, SMS logs, photos, videos, and other digital content;`,
      `Location information, which we may collect using cellular tower information, GPS technology, or other location services;`,
      `Social media information, including social media contacts, friends, shares, and comments from accounts to which you have granted Trust Science access;`,
      `Information we receive from third parties, including credit reporting agencies, mobile network providers, collection agencies, government agencies, data aggregators, and your employer;`,
      `Publicly available information;`,
      `Technical information collected from your mobile device, including traffic data, weblogs, device type, unique device identifiers, SIM card information, mobile network information, device operating system, IP address, and browser type; and`,
      `Unique application numbers, which are used to update the App and provide us with information about your installation.`,
    ],
  },
  {
    content: `In addition, Trust Science automatically collects anonymous information from your use of the Sites, such as IP \
address, browser type, date and time stamp, and clickstream data. Trust Science and analytics companies may use \
this anonymous data to help us understand how the services are used and for purposes such as security, analysis, \
and content generation.`,
  },
  {
    title: 'Retention and Transfer of Your Data',
    content: `Trust Science retains information for as long as the App is installed on your mobile device and will \
retain your information as long as necessary to comply with our legal obligations and enforce our legal rights.

Any information collected and used by Trust Science may be transferred, stored, or processed outside of the United \
States and Canada.`,
  },
  {
    title: 'Opt-out and Consent Withdrawal',
    content: `You may opt out of receiving marketing communications by emailing ${CONTACT_INFO.emailOptOut}. You may \
opt out of receiving push notifications and SMS messages by turning them off in App settings or at the device \
level through your settings. 

You may withdraw your consent to Trust Science’s future collection, use, and disclosure of your data by uninstalling \
the App or emailing us at ${CONTACT_INFO.emailConsent}. Email withdrawals will be processed within five business days. \
We may retain your data for audit or archival purposes or as required by applicable federal, state, and provincial \
laws.`,
  },
  {
    title: 'Security',
    content: `Trust Science takes all reasonably necessary precautions to secure your data. The App and Sites through \
which you provide your data use the Secure Sockets Layer (SSL) protocol. This protocol provides security for your \
information by encrypting it as it travels from your computer to our server. For security purposes, we then move \
all of your data, including your Trust Report, to an environment on a network that has controls in place to limit \
access to and secure the data.

Unfortunately, the transmission of information via the Internet is not completely secure. Although we do our best to \
protect all information, we cannot guarantee the security of your data transmitted to our Sites; any transmission is \
at your own risk. Once we have received your information, we will use strict procedures and security features to try \
to prevent unauthorized access.
`,
  },
  {
    title: 'Modification',
    content: `Trust Science may modify this Privacy Policy at any time, so please check the Privacy Policy \
periodically for changes. Trust Science will notify you by email in advance of any changes that, in our sole \
discretion, materially impact the collection, use, or disclosure of your data. If you object to any changes, \
you must withdraw consent as described above. If you do not withdraw your consent or continue to access or use \
the Smart Consent™ App or Sites, you will be considered to have expressly consented to the changes.`,
  },
  {
    title: 'Children',
    content: 'Children under the age of 18 may not install, use, or access the App or Sites.',
  },
  {
    title: 'Your Rights',
    content: `In accordance with the Fair Credit Reporting Act and Canadian credit reporting and privacy laws, Trust \
Science allows you to request a disclosure of the data we maintain about you, dispute data in your Trust File, \
ask a question, submit a complaint, request us to place a security alert in your file or block information \
resulting from fraud or identity theft, and request information regarding our policies and practices. In addition \
to viewing and requesting Trust Reports and submitting requests through the App or Sites, you can contact us by \
emailing us at ${CONTACT_INFO.emailSupport}, or call us toll-free at ${CONTACT_INFO.phoneNumber}.`,
  },
];
